import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgExtrudeIcon = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	stroke: "currentColor",
	strokeLinecap: "round",
	strokeLinejoin: "round",
	strokeWidth: 2,
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", { d: "M5 19h14" }),
		/* @__PURE__ */ _jsx("path", {
			d: "m5 19 3-7m11 7-3-7",
			opacity: .3
		}),
		/* @__PURE__ */ _jsx("path", { d: "M8 12h8M12 12V5M9 8l3-3 3 3" })
	]
});
export default SvgExtrudeIcon;
